/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Home/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AccountBalance from './AccountBalance/index'
import AppointmentBookings from './AppointmentBookings/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Logo from './Logo/index'
import MessageAlert from './MessageAlert/index'
import Person from './Person/index'
import PoweredBy from './PoweredBy/index'
import Practice from './Practice/index'
import React from 'react'
import Title from 'DesignSystem/Title/index'
import Version from './Version/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Home({
  children,
  viewPath = "/App/Account/Content/Content/Home"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Home.Horizontal"
  data-view-path={viewPath}
 style={{'--o-1-9V2T': isBefore ? 0 : 1,'--tx-2-9V2T': isBefore ? "-200px" : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Home.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Home.Vertical"
  data-view-path={viewPath}
 style={{'--pb-3-9V2T': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-4-9V2T': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pl-5-9V2T': isMedia.laptop ? typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-6-9V2T': isMedia.laptop ? typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL : typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mw-7-9V2T': isMedia.laptop ? "700px" : "100%",'--mw-8-9V2T': isMedia.laptop ? "500px" : "100%"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={isMedia.mobile}>
<Logo
  viewPath={`${viewPath}/Logo`}
/>
</fromFlow.When>
<div
  data-testid="Home.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-9-9V2T': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<Title
  viewPath={`${viewPath}/Title`}
 level="h1"
 text="Hello,"
 overflowX="none"
 lineHeight={1}
/>
<Person
  viewPath={`${viewPath}/Person`}
/>
</div>
<Practice
  viewPath={`${viewPath}/Practice`}
/>
<AccountBalance
  viewPath={`${viewPath}/AccountBalance`}
/>
<AppointmentBookings
  viewPath={`${viewPath}/AppointmentBookings`}
/>
<MessageAlert
  viewPath={`${viewPath}/MessageAlert`}
/>
<div
  data-testid="Home.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-4-9V2T': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-3-9V2T': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<PoweredBy
  viewPath={`${viewPath}/PoweredBy`}
/>
<Version
  viewPath={`${viewPath}/Version`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}